module.exports = __webpack_public_path__ + "static/media/notifications-empty.2f92b7c3.svg";